import _ from "ES/lib/lodash";
import getMPCommissionForEvent from "../../../utils/getMPCommissionForEvent";

export default function (opts) {
    let {
            event,
            Displaylists,
            mp_agreement,
            fee_main,
            fee_travel,
            fee_materials
        } = opts;

    const close_date = "payout on event date";
    const acceptance_date = "payout on acceptance";

    let commission = getMPCommissionForEvent(Displaylists, event);

    let commission_desc = (commission) + "%";
    let bname = _.get(Displaylists, ["universal", "whitelabels", event.bureauID, "bname"]);
    if (bname) {
        commission_desc += " " + bname;
    }
    commission_desc += " finder's fee";

    if (mp_agreement) {
        fee_main = 0;
        fee_travel = 0;
        fee_materials = 0;
        _.each(mp_agreement.fees, function (f) {
            if (f.flags_as_map.speaking_fee.is_set) {
                fee_main += f.fee;
            } else if (f.flags_as_map.travel.is_set) {
                fee_travel += f.fee;
            } else {
                fee_materials += f.fee;
            }
        });
    }

    let fees = [
        {
            due: acceptance_date,
            fee: fee_main * .5,
            description: "client pays deposit"
        },
        {
            due: acceptance_date,
            fee: -fee_main * (commission / 100),
            description: commission_desc
        },
        {
            due: close_date,
            fee: fee_main * .5,
            description: "client pays balance"
        }
    ];
    if (fee_travel > 0) {
        fees.push({
            due: close_date,
            fee: fee_travel,
            description: "client pays travel"
        });
    }
    if (fee_materials > 0) {
        fees.push({
            due: close_date,
            fee: fee_materials,
            description: "client pays materials"
        });
    }

    let grand_total = _.reduce(fees, function (sum, f) {
        return sum + f.fee;
    }, 0);

    return {
        fees,
        grand_total,
        fee_speaking: fee_main, //amount the buyer pays for speaking only (not travel or material)
        fee_materials,
        fee_travel

    };
}



// WEBPACK FOOTER //
// ./src/components/marketplace/MyLeadsTab/getLedgerData.js